"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _MountNode = _interopRequireDefault(require("./MountNode"));

exports.default = _MountNode.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/addons/MountNode/index.js
// module id = 1436
// module chunks = 0